module.exports = __webpack_public_path__ + "img/stalpro.68e01c05.png";